/**
 * Flash Sale List Component
 * 支持多个组件实例，互不影响
 */
(function() {
  'use strict';

  // 全局工具函数
  function getSite() {
    const currentDomain = window.location.hostname;
    switch (currentDomain) {
      case "uk.renogy.com": return {site:"UK",apiUrl:`https://shopify-api.renogy.com`,symbol: '£'};
      case "www.renogy.com": return {site:"US",apiUrl:`https://shopify-api.renogy.com`,symbol: '$'};
      case "ca.renogy.com": return {site:"CA",apiUrl:`https://shopify-api.renogy.com`,symbol: 'CAD$'};
      case "au.renogy.com": return {site:"AU",apiUrl:`https://shopify-api.renogy.com`,symbol: 'AU$'};
      case "de.renogy.com": return {site:"DE",apiUrl:`https://shopify-api.renogy.com`,symbol: '€'};
      case "eu.renogy.com": return {site:"EU",apiUrl:`https://shopify-api.renogy.com`,symbol: '€'};
      case "jp.renogy.com": return {site:"JP",apiUrl:`https://shopify-api.renogy.com`,symbol: '￥'};
      case "nl.renogy.com": return {site:"NL",apiUrl:`https://shopify-api.renogy.com`,symbol: '€'};
      case "it.renogy.com": return {site:"IT",apiUrl:`https://shopify-api.renogy.com`,symbol: '€'};
      case "es.renogy.com": return {site:"ES",apiUrl:`https://shopify-api.renogy.com`,symbol: '€'};
      case "za.renogy.com": return {site:"ZA",apiUrl:`https://shopify-api.renogy.com`,symbol: 'R'};
      case "fr.renogy.com": return {site:"FR",apiUrl:`https://shopify-api.renogy.com`,symbol: '€'};
      default: return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`,symbol: '$'};
    }
  }

  /**
   * 初始化 Flash Sale List 组件
   * @param {Object} config - 配置对象
   * @param {string} config.sectionId - Section ID
   * @param {Object} config.settings - Section settings
   */
  function initFlashSaleList(config) {
    const { sectionId, settings } = config;
    if (!sectionId) {
      console.warn('Flash Sale List: sectionId is required');
      return;
    }

    const flashSaleRoot = document.querySelector('.flash-sale-list-' + sectionId);
    if (!flashSaleRoot) {
      console.warn('Flash Sale List: root element not found for section', sectionId);
      return;
    }

    // ===== Placeholder Tooltip 初始化（仅非移动端） =====
    function initPlaceholderTooltips() {
      // 仅在非移动端执行
      if (window.innerWidth < 769) return;
      
      const inputContainers = flashSaleRoot.querySelectorAll('.form-email-container .input-with-button');
      
      inputContainers.forEach(function(container) {
        const input = container.querySelector('input[type="email"]');
        if (!input || !input.placeholder) return;
        
        // 更新输入框空状态类
        function updateInputEmptyState() {
          if (input.value.trim() === '') {
            container.classList.add('input-empty');
          } else {
            container.classList.remove('input-empty');
          }
        }
        
        // 初始检查输入框状态
        updateInputEmptyState();
        
        // 监听输入事件，更新空状态
        input.addEventListener('input', updateInputEmptyState);
        input.addEventListener('blur', updateInputEmptyState);
        input.addEventListener('focus', updateInputEmptyState);
        
        // 检查 placeholder 是否被截断
        function checkPlaceholderOverflow() {
          // 创建一个临时元素来测量 placeholder 文本的实际宽度
          const tempSpan = document.createElement('span');
          tempSpan.style.position = 'absolute';
          tempSpan.style.visibility = 'hidden';
          tempSpan.style.whiteSpace = 'nowrap';
          tempSpan.style.fontSize = window.getComputedStyle(input).fontSize;
          tempSpan.style.fontFamily = window.getComputedStyle(input).fontFamily;
          tempSpan.style.fontWeight = window.getComputedStyle(input).fontWeight;
          tempSpan.textContent = input.placeholder;
          document.body.appendChild(tempSpan);
          
          const placeholderWidth = tempSpan.offsetWidth;
          const inputWidth = input.offsetWidth;
          
          document.body.removeChild(tempSpan);
          
          // 如果 placeholder 文本宽度超过 input 宽度，则显示 tooltip
          if (placeholderWidth > inputWidth) {
            // 检查是否已经存在 tooltip
            let tooltip = container.querySelector('.placeholder-tooltip');
            if (!tooltip) {
              tooltip = document.createElement('div');
              tooltip.className = 'placeholder-tooltip';
              tooltip.textContent = input.placeholder;
              container.appendChild(tooltip);
            }
          } else {
            // 如果不需要 tooltip，移除它
            const existingTooltip = container.querySelector('.placeholder-tooltip');
            if (existingTooltip) {
              existingTooltip.remove();
            }
          }
        }
        
        // 初始检查
        checkPlaceholderOverflow();
        
        // 监听窗口大小变化，重新检查
        let resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(checkPlaceholderOverflow, 100);
        });
      });
    }
    
    // 初始化 tooltip（延迟执行，确保 DOM 已渲染）
    setTimeout(initPlaceholderTooltips, 100);
    
    // ===== 原有表单提交处理 =====
    const forms = flashSaleRoot.querySelectorAll('#subscript-form-' + sectionId + ', form.subscript-form');
    
    forms.forEach(function(form) {
      if (!form) return;
      
      const emailInput = form.querySelector('input[name="sub-email"]');
      const buttons = form.querySelectorAll('button.subscript-button');
      if (!emailInput || !buttons || buttons.length === 0) return;
      
      // 获取所有按钮的原始文本（假设它们都有相同的文本）
      const originalText = buttons[0].textContent;
      const testUrl = 'https://d-shopify-api.renogy.cn';
      const prodUrl = 'https://shopify-api.renogy.com';
      
      // 启用所有按钮
      buttons.forEach(function(btn) {
        btn.removeAttribute('disabled');
      });
      
      form.addEventListener('submit', async function(event) {
        event.preventDefault();
        
        // 获取当前可见的按钮（用于获取宽度等属性）
        const visibleButton = Array.from(buttons).find(function(btn) {
          const style = window.getComputedStyle(btn);
          return style.display !== 'none' && style.visibility !== 'hidden';
        }) || buttons[0];
        
        const buttonWidth = visibleButton.offsetWidth;
        // 禁用所有按钮和输入框
        buttons.forEach(function(btn) {
          btn.setAttribute('disabled', 'disabled');
        });
        emailInput.setAttribute('disabled', 'disabled');
        
        const isProduction = window.location.hostname.indexOf('renogy.com') > -1;
        const apiUrl = isProduction ? prodUrl : testUrl;
        const currentDomain = isProduction ? window.location.hostname : 'shopify-uk.renogy.cn';
        const storeName = getSite().site;
        const tagName = settings.tag_name || '';
        
        let queryParams = `Email=${encodeURIComponent(emailInput.value)}&storeName=${storeName}`;
        if (tagName && tagName.trim() !== '') {
          queryParams += `&tagName=${encodeURIComponent(tagName)}`;
        }
        
        try {
          const response = await fetch(`${apiUrl}/api/shopify-client/subscript?${queryParams}`, {
            method: "GET",
            headers: {
              'X-Origin-Domain': currentDomain
            },
          });
          const result = await response.json();
          
          if (result.code === 200) {
            const formField = form.querySelector('.form__field');
            const successMessage = form.querySelector('.subscript-success-message');
            
            if (formField && successMessage) {
              formField.style.display = 'none';
              successMessage.style.display = 'flex';
              successMessage.classList.remove('is-animate');
              void successMessage.offsetWidth; // reflow 触发动画重置
              successMessage.classList.add('is-animate');
              
              // 检查文本是否被截断，如果被截断则添加 tooltip
              const successSpan = successMessage.querySelector('span');
              if (successSpan) {
                const fullText = successSpan.textContent.trim();
                
                // 检查并更新 tooltip 的函数
                function checkAndUpdateTooltip() {
                  const isOverflowing = successSpan.scrollWidth > successSpan.offsetWidth;
                  let tooltip = successMessage.querySelector('.success-message-tooltip');
                  
                  if (isOverflowing) {
                    // 如果文本被截断，创建或更新 tooltip
                    if (!tooltip) {
                      tooltip = document.createElement('div');
                      tooltip.className = 'success-message-tooltip';
                      successMessage.appendChild(tooltip);
                    }
                    tooltip.textContent = fullText;
                  } else {
                    // 如果文本没有被截断，移除 tooltip
                    if (tooltip) {
                      tooltip.remove();
                    }
                  }
                }
                
                // 使用 requestAnimationFrame 确保 DOM 已更新
                requestAnimationFrame(function() {
                  checkAndUpdateTooltip();
                  
                  // 监听窗口大小变化，重新检查
                  let resizeTimer;
                  const resizeHandler = function() {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(checkAndUpdateTooltip, 100);
                  };
                  window.addEventListener('resize', resizeHandler);
                  
                  // 当成功消息被移除时，清理事件监听器
                  const observer = new MutationObserver(function(mutations) {
                    if (!document.body.contains(successMessage)) {
                      window.removeEventListener('resize', resizeHandler);
                      observer.disconnect();
                    }
                  });
                  observer.observe(document.body, { childList: true, subtree: true });
                });
              }
              
              const formContainer = form.closest('.form-email-container');
              if (formContainer) {
                formContainer.classList.add('is-success');
                // 隐藏 pad 按钮
                const padButton = formContainer.querySelector('.subscript-button-pad');
                if (padButton) {
                  padButton.style.display = 'none';
                }
              }
              
              emailInput.value = '';
            }
          } else {
            if (window.Swal) {
              Swal.fire({
                title: "Failed!",
                text: "Subscription failed. Please try again.",
                icon: "error",
                customClass: {
                  popup: "subscript-rg-dialog-popup",
                },
              });
            }
            // 恢复所有按钮和输入框
            buttons.forEach(function(btn) {
              btn.removeAttribute('disabled');
              btn.style.width = '';
            });
            emailInput.removeAttribute('disabled');
          }
        } catch (error) {
          if (window.Swal) {
            Swal.fire({
              title: "Failed!",
              text: "An error occurred. Please try again.",
              icon: "error",
              customClass: {
                popup: "subscript-rg-dialog-popup",
              },
            });
          }
          // 恢复所有按钮和输入框
          buttons.forEach(function(btn) {
            btn.removeAttribute('disabled');
            btn.style.width = '';
          });
          emailInput.removeAttribute('disabled');
        }
      });
    });

    // ===== Flash sale countdown (start / end) =====
    const startWrapper = flashSaleRoot.querySelector('.coupon-lottery-countdown-start');
    const endWrapper = flashSaleRoot.querySelector('.coupon-lottery-countdown-end');
    const startTime = settings.countdown_start_time || '';
    const endTime = settings.countdown_end_time || '';

    // 保存定时器 ID，用于清理
    let startCountdownInterval = null;
    let endCountdownInterval = null;
    let hasRefreshedOnEnd = false; // 防止重复刷新
    const reloadLockPrefix = 'flashSaleReloadLock:';

    function shouldReloadOnce(lockId) {
      if (!lockId) return false;
      const lockKey = reloadLockPrefix + lockId;
      try {
        if (window.sessionStorage.getItem(lockKey) === '1') return false;
        window.sessionStorage.setItem(lockKey, '1');
      } catch (e) {
        // ignore storage errors (private mode, quota, etc.)
      }
      return true;
    }

    if (startTime || endTime) {
      function normalizeCountdownTime(timeString) {
        if (!timeString) return '';
        return timeString.toString().replace(/["',]/g, '').trim();
      }

      function updateNumberWithAnimation(element, newValue) {
        if (!element) return;
        const currentNumber = element.querySelector('.countdown-number');
        const nextNumber = element.querySelector('.countdown-number-next');
        if (!currentNumber || !nextNumber) return;

        const currentDisplayValue = currentNumber.textContent.trim();
        if (currentDisplayValue === newValue.toString()) {
          return;
        }

        nextNumber.textContent = newValue;
        currentNumber.classList.remove('roll-down-old');
        nextNumber.classList.remove('roll-down-new');
        void element.offsetWidth;
        currentNumber.classList.add('roll-down-old');
        nextNumber.classList.add('roll-down-new');

        setTimeout(() => {
          currentNumber.textContent = newValue;
          currentNumber.classList.remove('roll-down-old');
          nextNumber.classList.remove('roll-down-new');
          currentNumber.style.transform = 'translateY(0)';
          nextNumber.style.transform = 'translateY(-100%)';
        }, 500);
      }

      function updateCountdown(countDownWrapper, targetTime, isEndCountdown) {
        if (!countDownWrapper || !targetTime) return;
        const normalizedTime = normalizeCountdownTime(targetTime);
        if (!normalizedTime) return;
        
        const targetDate = new Date(normalizedTime).getTime();
        if (isNaN(targetDate)) {
          console.warn('Flash Sale List: Invalid countdown time format', targetTime);
          return;
        }
        
        const now = Date.now();
        const timeLeft = Math.max(0, targetDate - now);

        // 倒计时结束时，触发页面刷新
        if (timeLeft === 0 || timeLeft < 0) {
          if (isEndCountdown && endCountdownInterval) {
            clearInterval(endCountdownInterval);
            endCountdownInterval = null;
          } else if (!isEndCountdown && startCountdownInterval) {
            clearInterval(startCountdownInterval);
            startCountdownInterval = null;
          }
          
          // 倒计时结束后刷新页面（跨刷新仅一次）
          const reloadLockId = `${sectionId}:${isEndCountdown ? 'end' : 'start'}:${normalizedTime}`;
          if (!hasRefreshedOnEnd && shouldReloadOnce(reloadLockId)) {
            hasRefreshedOnEnd = true;
            window.location.reload();
          }
          return;
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const formattedDays = days < 10 ? '0' + days : days;
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const formattedHours = hours < 10 ? '0' + hours : hours;
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
        const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

        updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-day'), formattedDays);
        updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-hour'), formattedHours);
        updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-minutes'), formattedMinutes);
        updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-second'), formattedSeconds);
      }

      function startCountdown(wrapper, targetTime, isEndCountdown) {
        if (!wrapper || !targetTime) return;
        
        // 清除之前的定时器
        if (isEndCountdown && endCountdownInterval) {
          clearInterval(endCountdownInterval);
          endCountdownInterval = null;
        } else if (!isEndCountdown && startCountdownInterval) {
          clearInterval(startCountdownInterval);
          startCountdownInterval = null;
        }
        
        const normalizedTime = normalizeCountdownTime(targetTime);
        if (!normalizedTime) return;
        
        // 初始更新
        updateCountdown(wrapper, normalizedTime, isEndCountdown);
        
        // 设置定时器
        const intervalId = setInterval(() => {
          updateCountdown(wrapper, normalizedTime, isEndCountdown);
        }, 1000);
        
        // 保存定时器 ID
        if (isEndCountdown) {
          endCountdownInterval = intervalId;
        } else {
          startCountdownInterval = intervalId;
        }
      }

      function renderFlashSaleCountdown() {
        const normalizedStartTime = normalizeCountdownTime(startTime);
        const normalizedEndTime = normalizeCountdownTime(endTime);
        
        const now = Date.now();
        const hasStart = !!normalizedStartTime;
        const hasEnd = !!normalizedEndTime;
        const startTargetDate = hasStart ? new Date(normalizedStartTime).getTime() : null;
        const endTargetDate = hasEnd ? new Date(normalizedEndTime).getTime() : null;

        // 检查时间是否有效
        if (hasStart && isNaN(startTargetDate)) {
          console.warn('Flash Sale List: Invalid start time format', startTime);
        }
        if (hasEnd && isNaN(endTargetDate)) {
          console.warn('Flash Sale List: Invalid end time format', endTime);
        }

        // 活动未开始：显示开始倒计时，隐藏结束倒计时
        if (hasStart && !isNaN(startTargetDate) && startTargetDate > now) {
          if (startWrapper) {
            startWrapper.style.display = 'flex';
            startCountdown(startWrapper, normalizedStartTime, false);
          }
          if (endWrapper) {
            endWrapper.style.display = 'none';
          }
          return;
        }

        // 活动已开始且未结束：隐藏开始倒计时，显示结束倒计时
        if (hasEnd && !isNaN(endTargetDate) && endTargetDate > now) {
          if (startWrapper) {
            startWrapper.style.display = 'none';
            if (startCountdownInterval) {
              clearInterval(startCountdownInterval);
              startCountdownInterval = null;
            }
          }
          if (endWrapper) {
            endWrapper.style.display = 'flex';
            startCountdown(endWrapper, normalizedEndTime, true);
          }
          return;
        }

        // 活动已结束或未配置时间：隐藏所有倒计时
        if (startWrapper) {
          startWrapper.style.display = 'none';
          if (startCountdownInterval) {
            clearInterval(startCountdownInterval);
            startCountdownInterval = null;
          }
        }
        if (endWrapper) {
          endWrapper.style.display = 'none';
          if (endCountdownInterval) {
            clearInterval(endCountdownInterval);
            endCountdownInterval = null;
          }
        }
      }

      renderFlashSaleCountdown();
    }

    // ===== 键盘上方表单处理 =====
    let overlay = document.getElementById('keyboard-form-overlay-' + sectionId);
    
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'flash-sale-keyboard-form-overlay';
      overlay.id = 'keyboard-form-overlay-' + sectionId;
      overlay.style.display = 'none';
      
      const termsPrefix = settings.terms_prefix || '*By submitting this form, I agree to the';
      const termsMiddle = settings.terms_middle || 'and';
      const termsText = settings.terms_text || 'Terms of Service';
      const privacyText = settings.privacy_text || 'Privacy Policy';
      const termsLink = settings.terms_link || '/pages/terms-of-service';
      const privacyLink = settings.privacy_link || '/pages/privacy-policy';
      const termsTextColor = settings.terms_text_color || '';
      const termsLinkColor = settings.terms_link_color || '';
      const inputPlaceholder = settings.input_placeholder_text || 'Enter your email';
      const formButtonText = settings.form_button_text || 'Notify Me';
      
      overlay.innerHTML = `
        <div class="flash-sale-keyboard-form-container">
          <div class="flash-sale-keyboard-form-content">
            <form method="post" class="form subscript-form keyboard-form" data-section-id="${sectionId}">
              <div class="subscript-success-message" style="display: none;">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="#00805E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>${settings.success_message_full || "You're in! We'll remind you."}</span>
              </div>
              <div class="form__field">
                <div class="input-with-button input-with-button--md-up">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <rect width="20" height="20" fill="white"/>
                    <mask id="path-1-inside-1_42_6109_${sectionId}" fill="white">
                      <rect x="2.85718" y="3.92871" width="14.2857" height="12.1429" rx="0.285714"/>
                    </mask>
                    <rect x="2.85718" y="3.92871" width="14.2857" height="12.1429" rx="0.285714" stroke="#1C1C1C" stroke-width="2.85714" mask="url(#path-1-inside-1_42_6109_${sectionId})"/>
                    <path d="M16.1921 5.88797L10.6689 10.8588C10.2886 11.2011 9.71132 11.2011 9.33102 10.8588L3.80786 5.88797L4.7635 4.82617L9.99997 9.53899L15.2364 4.82617L16.1921 5.88797Z" fill="#1C1C1C"/>
                  </svg>
                  <input type="email" class="input w-full focus-inset keyboard-form-email-input" name="sub-email" value="" placeholder="${inputPlaceholder}" autocomplete="email" aria-required="true" required>
                </div>
                <div class="keyboard-from-submit-line"></div>
                <button disabled class="btn btn--primary subscript-button keyboard-form-submit-btn">${formButtonText}</button>
              </div>
            </form>
          </div>
          <div class="terms-text-bottom" style="${termsTextColor ? 'color: ' + termsTextColor + ';' : ''}">
            ${termsPrefix} 
            <a href="${termsLink}" target="_blank" class="terms-link" style="${termsLinkColor ? 'color: ' + termsLinkColor + ';' : ''}">
              ${termsText}
            </a>
            ${termsMiddle}
            <a href="${privacyLink}" target="_blank" class="terms-link" style="${termsLinkColor ? 'color: ' + termsLinkColor + ';' : ''}">
              ${privacyText}
            </a>
          </div>
        </div>
      `;
      
      document.body.appendChild(overlay);
    }
    
    const emailInput = overlay.querySelector('.keyboard-form-email-input');
    const submitBtn = overlay.querySelector('.keyboard-form-submit-btn');
    const form = overlay.querySelector('.keyboard-form');
    
    if (!overlay || !form) {
      console.warn('Flash sale keyboard form container creation failed for section', sectionId);
      return;
    }

    // 检测移动设备（包括iOS和Android）
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
             (window.innerWidth <= 768 && 'ontouchstart' in window);
    }

    // 使用事件委托处理所有卡片的按钮点击（限定在当前组件内）
    let currentClickedButton = null;
    let mobileHandled = false; // 标记移动设备是否已在点击事件中处理
    flashSaleRoot.addEventListener('click', function(e) {
      const button = e.target.closest('.flash-sale-prebadge-button');
      if (button && button.dataset.formId) {
        e.preventDefault();
        currentClickedButton = button;
        // 保存用户交互事件，用于移动端键盘弹出
        const userEvent = e;
        const isMobile = isMobileDevice();
        
        // 移动设备特殊处理：在用户点击事件中立即准备聚焦
        if (isMobile && emailInput) {
          mobileHandled = true; // 标记已处理
          
          // 确保overlay完全隐藏且状态干净（清除之前可能残留的样式和class）
          const formContainer = overlay.querySelector('.flash-sale-keyboard-form-container');
          
          // 先确保overlay是完全隐藏的状态
          overlay.style.display = 'none';
          overlay.classList.remove('is-visible');
          overlay.style.opacity = '';
          overlay.style.transition = 'none';
          
          if (formContainer) {
            formContainer.style.transform = '';
            formContainer.style.top = '';
            formContainer.style.bottom = '';
            formContainer.style.transition = 'none';
          }
          
          // 强制重排，确保所有清理操作已生效
          void overlay.offsetHeight;
          
          // 现在开始显示：先设置display
          overlay.style.display = 'block';
          
          // 强制重排，确保display:block已生效
          void overlay.offsetHeight;
          
          // 然后设置位置和transform（在transition禁用的情况下）
          // 在移动设备上，等待键盘弹出后立即固定在键盘上方
          if (formContainer) {
            // 先设置为底部，但准备在键盘弹出后立即调整
            formContainer.style.top = 'auto';
            formContainer.style.bottom = '0';
            formContainer.style.transform = 'translateY(0)';
          }
          overlay.style.opacity = '1';
          
          // 强制重排，确保所有样式已应用
          void formContainer ? formContainer.offsetHeight : overlay.offsetHeight;
          
          // 添加is-visible class（用于opacity动画，但不影响transform，因为transform已通过内联样式设置）
          overlay.classList.add('is-visible');
          
          // 再次强制重排，确保is-visible class已应用
          void overlay.offsetHeight;
          
          // 在移动设备上，保持formContainer的transition禁用，只恢复overlay的transition
          // 这样可以避免formContainer的transform动画，同时保持overlay的opacity动画
          requestAnimationFrame(function() {
            overlay.style.transition = ''; // 只恢复overlay的transition
            // formContainer的transition保持禁用，避免transform动画
          });
          
          // 在用户交互上下文中立即尝试聚焦（不等待任何异步操作）
          emailInput.removeAttribute('disabled');
          emailInput.value = '';
          
          // 立即聚焦
          emailInput.focus({ preventScroll: false });
          
          // 如果focus没有立即生效，使用click事件
          if (document.activeElement !== emailInput) {
            const clickEvt = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
              detail: 1
            });
            emailInput.dispatchEvent(clickEvt);
            setTimeout(function() {
              emailInput.focus({ preventScroll: false });
            }, 0);
          }
          
          // 监听键盘弹出和收起，动态调整位置
          if (formContainer) {
            const savedInitialHeight = window.innerHeight;
            let lastTopPosition = null;
            let updateTimer = null;
            
            const updatePositionToKeyboard = function() {
              // 清除之前的定时器，避免频繁更新
              if (updateTimer) {
                clearTimeout(updateTimer);
              }
              
              // 使用防抖，避免频繁更新导致跳动
              updateTimer = setTimeout(function() {
                // 保存定时器引用，以便清理
                formContainer._updateTimer = updateTimer;
                if (window.visualViewport) {
                  const viewportHeight = window.visualViewport.height;
                  const viewportTop = window.visualViewport.offsetTop || 0;
                  const heightDiff = savedInitialHeight - viewportHeight;
                  
                  // 如果检测到键盘弹出（viewport高度明显减小）
                  if (heightDiff > 100) {
                    const topPosition = viewportTop + viewportHeight;
                    // 只有当位置真正改变时才更新，避免不必要的跳动
                    if (lastTopPosition !== topPosition) {
                      formContainer.style.top = topPosition + 'px';
                      formContainer.style.bottom = 'auto';
                      formContainer.style.transform = 'translateY(-100%)';
                      formContainer.style.transition = 'none'; // 保持禁用transition，避免动画
                      lastTopPosition = topPosition;
                      isKeyboardVisible = true;
                    }
                  } else {
                    // 键盘收起，移回底部
                    if (lastTopPosition !== null) {
                      formContainer.style.top = 'auto';
                      formContainer.style.bottom = '0';
                      formContainer.style.transform = 'translateY(0)';
                      formContainer.style.transition = 'none';
                      lastTopPosition = null;
                      isKeyboardVisible = false;
                    }
                  }
                } else {
                  // 不支持visualViewport的情况
                  const currentHeight = window.innerHeight;
                  const heightDiff = savedInitialHeight - currentHeight;
                  
                  if (heightDiff > 100) {
                    // 键盘弹出
                    if (lastTopPosition !== currentHeight) {
                      formContainer.style.top = currentHeight + 'px';
                      formContainer.style.bottom = 'auto';
                      formContainer.style.transform = 'translateY(-100%)';
                      formContainer.style.transition = 'none';
                      lastTopPosition = currentHeight;
                      isKeyboardVisible = true;
                    }
                  } else {
                    // 键盘收起
                    if (lastTopPosition !== null) {
                      formContainer.style.top = 'auto';
                      formContainer.style.bottom = '0';
                      formContainer.style.transform = 'translateY(0)';
                      formContainer.style.transition = 'none';
                      lastTopPosition = null;
                      isKeyboardVisible = false;
                    }
                  }
                }
              }, 50); // 50ms防抖
            };
            
            // 立即检查一次（键盘可能已经弹出）
            setTimeout(updatePositionToKeyboard, 100);
            setTimeout(updatePositionToKeyboard, 200);
            setTimeout(updatePositionToKeyboard, 300);
            
            // 持续监听键盘状态变化
            if (window.visualViewport) {
              window.visualViewport.addEventListener('resize', updatePositionToKeyboard);
              window.visualViewport.addEventListener('scroll', updatePositionToKeyboard);
            } else {
              window.addEventListener('resize', updatePositionToKeyboard);
            }
            
            // 保存清理函数，以便在关闭表单时调用
            formContainer._keyboardPositionUpdater = updatePositionToKeyboard;
            formContainer._updateTimer = updateTimer;
          }
        } else {
          mobileHandled = false;
        }
        
        showKeyboardForm(userEvent);
      }
    });

    // 显示/隐藏表单
    let initialViewportHeight = window.innerHeight;
    let isKeyboardVisible = false;

    function showKeyboardForm(userEvent) {
      initialViewportHeight = window.innerHeight;
      isKeyboardVisible = false;
      
      const isMobile = isMobileDevice();
      const formContainer = overlay.querySelector('.flash-sale-keyboard-form-container');
      
      // 移动设备已经在点击事件中处理了立即显示和聚焦，这里跳过重复处理
      if (isMobile && mobileHandled) {
        // 只做必要的状态检查，位置调整已在点击事件中处理
        // 重置标记
        mobileHandled = false;
        // 移动设备上不需要调用 updateFormPosition，因为位置调整已在点击事件中处理
        return; // 提前返回，避免执行后续可能引起闪烁的操作
      }
      
      // 非移动设备或移动设备未在点击事件中处理：正常显示流程
      if (emailInput) {
        emailInput.removeAttribute('disabled');
        emailInput.value = '';
      }
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.style.width = '';
      }
      const formField = form.querySelector('.form__field');
      const successMessage = form.querySelector('.subscript-success-message');
      if (formField) {
        formField.style.display = '';
      }
      if (successMessage) {
        successMessage.style.display = 'none';
        successMessage.classList.remove('is-animate');
      }
      
      if (overlay.style.display !== 'block') {
        overlay.style.display = 'block';
      }
      
      if (formContainer) {
        formContainer.style.top = 'auto';
        formContainer.style.bottom = '0';
      }
      
      // 正常动画显示
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          overlay.classList.add('is-visible');
          if (emailInput) {
            emailInput.focus();
          }
          updateFormPosition();
        });
      });
      
      // 重置标记
      mobileHandled = false;
      
      // 保留额外的延迟更新位置，用于键盘弹出后的位置调整
      setTimeout(function() {
        updateFormPosition();
      }, 100);
      setTimeout(updateFormPosition, 300);
      setTimeout(updateFormPosition, 500);
      setTimeout(updateFormPosition, 800);
    }

    function hideKeyboardForm() {
      // 立即移除所有状态，不等待动画
      overlay.classList.remove('is-visible');
      const formContainer = overlay.querySelector('.flash-sale-keyboard-form-container');
      
      // 清理键盘位置监听器
      if (formContainer && formContainer._keyboardPositionUpdater) {
        if (formContainer._updateTimer) {
          clearTimeout(formContainer._updateTimer);
        }
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', formContainer._keyboardPositionUpdater);
          window.visualViewport.removeEventListener('scroll', formContainer._keyboardPositionUpdater);
        } else {
          window.removeEventListener('resize', formContainer._keyboardPositionUpdater);
        }
        formContainer._keyboardPositionUpdater = null;
        formContainer._updateTimer = null;
      }
      
      // 立即重置所有内联样式，避免下次打开时状态冲突
      overlay.style.opacity = '';
      overlay.style.transition = '';
      overlay.style.display = 'none';
      
      if (formContainer) {
        formContainer.style.top = '';
        formContainer.style.bottom = '';
        formContainer.style.transform = '';
        formContainer.style.transition = ''; // 关闭时恢复transition，以便下次打开时可以使用
      }
      
      if (emailInput) {
        emailInput.blur();
        emailInput.value = '';
        emailInput.removeAttribute('disabled');
      }
      const formField = form.querySelector('.form__field');
      const successMessage = form.querySelector('.subscript-success-message');
      if (formField) {
        formField.style.display = '';
      }
      if (successMessage) {
        successMessage.style.display = 'none';
        successMessage.classList.remove('is-animate');
      }
      if (submitBtn) {
        submitBtn.removeAttribute('disabled');
        submitBtn.style.width = '';
      }
      isKeyboardVisible = false;
      // 重置移动设备处理标记
      mobileHandled = false;
      initialViewportHeight = window.innerHeight;
    }

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        hideKeyboardForm();
      }
    });

    const formContainer = overlay.querySelector('.flash-sale-keyboard-form-container');
    if (formContainer) {
      formContainer.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }

    function updateFormPosition() {
      const formContainer = overlay.querySelector('.flash-sale-keyboard-form-container');
      if (!formContainer || overlay.style.display !== 'block') return;
      
      // 在移动设备上，如果已经有专门的键盘位置更新器在工作，就不需要updateFormPosition再调整
      const isMobile = isMobileDevice();
      if (isMobile && formContainer && formContainer._keyboardPositionUpdater) {
        // 移动设备上已经有专门的键盘位置更新器，不在这里调整，避免冲突
        return;
      }
      
      if (!isKeyboardVisible) {
        initialViewportHeight = window.innerHeight;
      }
      
      if (window.visualViewport) {
        const viewportHeight = window.visualViewport.height;
        const viewportTop = window.visualViewport.offsetTop || 0;
        const heightDiff = initialViewportHeight - viewportHeight;
        
        if (heightDiff > 150) {
          isKeyboardVisible = true;
          const topPosition = viewportTop + viewportHeight;
          formContainer.style.top = topPosition + 'px';
          formContainer.style.bottom = 'auto';
          formContainer.style.transform = 'translateY(-100%)';
        } else {
          isKeyboardVisible = false;
          formContainer.style.top = 'auto';
          formContainer.style.bottom = '0';
          formContainer.style.transform = '';
        }
      } else {
        const currentHeight = window.innerHeight;
        const heightDiff = initialViewportHeight - currentHeight;
        
        if (heightDiff > 150) {
          isKeyboardVisible = true;
          formContainer.style.top = currentHeight + 'px';
          formContainer.style.bottom = 'auto';
          formContainer.style.transform = 'translateY(-100%)';
        } else {
          isKeyboardVisible = false;
          formContainer.style.top = 'auto';
          formContainer.style.bottom = '0';
          formContainer.style.transform = '';
        }
      }
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateFormPosition);
      window.visualViewport.addEventListener('scroll', updateFormPosition);
    } else {
      window.addEventListener('resize', updateFormPosition);
    }

    if (emailInput && submitBtn) {
      emailInput.addEventListener('input', function() {
        if (emailInput.value.trim() !== '') {
          submitBtn.removeAttribute('disabled');
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
        }
      });
    }

    if (form) {
      form.addEventListener('submit', async function(event) {
        event.preventDefault();
        
        if (!emailInput || !submitBtn) return;
        
        const buttonWidth = submitBtn.offsetWidth;
        submitBtn.style.width = buttonWidth + 'px';
        submitBtn.setAttribute('disabled', 'disabled');
        emailInput.setAttribute('disabled', 'disabled');
        
        const testUrl = 'https://d-shopify-api.renogy.cn';
        const prodUrl = 'https://shopify-api.renogy.com';
        const isProduction = window.location.hostname.indexOf('renogy.com') > -1;
        const apiUrl = isProduction ? prodUrl : testUrl;
        const currentDomain = isProduction ? window.location.hostname : 'shopify-uk.renogy.cn';
        const storeName = getSite().site;
        const tagName = settings.tag_name || '';
        
        let queryParams = `Email=${encodeURIComponent(emailInput.value)}&storeName=${storeName}`;
        if (tagName && tagName.trim() !== '') {
          queryParams += `&tagName=${encodeURIComponent(tagName)}`;
        }
        
        try {
          const response = await fetch(`${apiUrl}/api/shopify-client/subscript?${queryParams}`, {
            method: "GET",
            headers: {
              'X-Origin-Domain': currentDomain
            },
          });
          const result = await response.json();
          
          if (result.code === 200) {
            const formField = form.querySelector('.form__field');
            const successMessage = form.querySelector('.subscript-success-message');
            
            if (formField && successMessage) {
              formField.style.display = 'none';
              successMessage.style.display = 'flex';
              successMessage.classList.remove('is-animate');
              void successMessage.offsetWidth; // reflow 触发动画重置
              successMessage.classList.add('is-animate');
              emailInput.value = '';
              
              if (currentClickedButton) {
                currentClickedButton.style.display = 'none';
                const successMsg = currentClickedButton.nextElementSibling;
                if (successMsg && successMsg.classList.contains('flash-sale-button-success-message')) {
                  successMsg.style.display = 'flex';
                }
                currentClickedButton = null;
              }
              
              hideKeyboardForm();
            }
          } else {
            if (window.Swal) {
              Swal.fire({
                title: "Failed!",
                text: "Subscription failed. Please try again.",
                icon: "error",
                customClass: {
                  popup: "subscript-rg-dialog-popup",
                },
              });
            }
            submitBtn.removeAttribute('disabled');
            emailInput.removeAttribute('disabled');
            submitBtn.style.width = '';
          }
        } catch (error) {
          if (window.Swal) {
            Swal.fire({
              title: "Failed!",
              text: "An error occurred. Please try again.",
              icon: "error",
              customClass: {
                popup: "subscript-rg-dialog-popup",
              },
            });
          }
          submitBtn.removeAttribute('disabled');
          emailInput.removeAttribute('disabled');
          submitBtn.style.width = '';
        }
      });
    }
  }

  // 导出到全局
  window.FlashSaleList = {
    init: initFlashSaleList
  };
})();
